import { Pipe, PipeTransform } from '@angular/core';
import { Project } from '@portal-core/projects/models/project.model';
import { ProjectsService } from '@portal-core/projects/services/projects.service';
import { Observable, of } from 'rxjs';

@Pipe({
  name: 'mcProjectAsync'
})
export class ProjectAsyncPipe implements PipeTransform {
  constructor(private projectsService: ProjectsService) { }

  transform(projectId: number | null | undefined, allowApiRequest: boolean = false): Observable<Project | null> {

    if (typeof projectId !== 'number') {
      return of(null);
    }

    return this.projectsService.getItemById$(projectId, {
      allowApiRequest
    });
  }
}
